import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetch6 } from '../../Apis/commonApis';
import { notify } from '../../constants/notifyconstants';
import moment from 'moment';

const initialState = {
  loading: false,
  progressLoading: false,
  error: null,
  isDataFiltered: false,
  generalPageData: [],
  branchesPageData: [],
  inventoryPageData: [],
  itemConsumtion: [],
  itemWasted: [],
  dashboardFilter: {
    branches: null,
    branch_tags: null,
  },
};

export const getGeneralPageDashboard: any = createAsyncThunk(
  'dashboard/general',
  async (body: any) => {
    const Body = { ...body };
    Body['date_from'] = moment(body?.date?.[0]).format('YYYY-MM-DD');
    Body['date_to'] = moment(body?.date?.[1]).format('YYYY-MM-DD');
    Body['group_by'] = body.groupby;
    if (Body.date) delete Body.date;
    if (Body.metric) delete Body.metric;
    if (Body.groupby) delete Body.groupby;
    if (
      Body['date_from'] === 'Invalid date' ||
      Body['date_to'] === 'Invalid date'
    )
      return;
    try {
      const result = await fetch6(
        `${process.env.REACT_APP_BASEURL}/reports/dashboard-summary`,
        Body
      );
      console.log('overview', { result });
      let data: any = {};

      Object.entries(result.grouped).forEach(([date, values]: any) => {
        Object.entries(values).forEach(([key, value]) => {
          if (!data[key]) {
            data[key] = [];
          }
          data[key].push({ date, value });
        });
      });
      console.log({ method: body.metric });

      if (body.metric === 'top_payments_by_sales') {
        data = {
          top_payments_by_sales: result?.top_payments_by_sales?.map(
            (e: any) => ({
              payment: e.name,
              net_sales: e.total,
            })
          ),
        };
      } else if (body.metric === 'top_products_by_sales') {
        data = {
          top_products_by_sales: result?.top_products_by_sales?.map(
            (e: any) => ({
              product: e.name,
              net_sales: e.sales,
            })
          ),
        };
      } else if (body.metric === 'net_sales_per_hour') {
        data = {
          net_sales_per_hour: result?.net_sales_per_hour?.map((e: any) => ({
            hour: e.hour,
            net_sales: e.value,
          })),
        };
      } else if (body.metric === 'top_branches_by_sales') {
        data = {
          top_branches_by_sales: result?.top_branches_by_sales?.map(
            (e: any) => ({
              branch: e.branch_name,
              net_sales: e.gross_sales,
            })
          ),
        };
      }
      // return result;
      return {
        data:
          data?.[body.metric]?.sort(
            (a: any, b: any) =>
              new Date(a.date).getTime() - new Date(b.date).getTime()
          ) || [],
      };
    } catch (error: any) {
      return notify(error?.response?.data?.message);
    }
  }
);

export const getInventoryItemsConsumtion: any = createAsyncThunk(
  'dashboard/consumption',
  async (body: any) => {
    try {
      const result = await fetch6(
        `${process.env.REACT_APP_BASEURL}/reports/overview/top-items/consumed`,
        body
      );
      return result;
    } catch (error: any) {
      return notify(error?.response?.data?.message);
    }
  }
);

export const getInventoryItemsWasted: any = createAsyncThunk(
  'dashboard/wasted',
  async (body: any) => {
    try {
      const result = await fetch6(
        `${process.env.REACT_APP_BASEURL}/reports/overview/top-items/wasted`,
        body
      );
      return result;
    } catch (error: any) {
      return notify(error?.response?.data?.message);
    }
  }
);

export const getBranchesPageData: any = createAsyncThunk(
  'dashboard/branches',
  async (body: any) => {
    try {
      const result = await fetch6(
        `${process.env.REACT_APP_BASEURL}/reports/overview/branches`,
        body
      );
      return result;
    } catch (error: any) {
      return notify(error?.response?.data?.message);
    }
  }
);

export const getInventoryPageData: any = createAsyncThunk(
  'dashboard/inventory',
  async (body: any) => {
    try {
      const result = await fetch6(
        `${process.env.REACT_APP_BASEURL}/reports/overview/inventory`,
        body
      );
      return result;
    } catch (error: any) {
      return notify(error?.response?.data?.message);
    }
  }
);

const dashboardSlice: any = createSlice({
  name: 'dashboardApis',
  initialState,
  reducers: {
    setProgressLoading(state: any = initialState, action: any) {
      state.progressLoading = action.payload;
    },
    setIsDataFiltered(state: any = initialState, action: any) {
      state.progressLoading = action.payload;
    },
    setDashboardFilterObj(state: any = initialState, action: any) {
      state.dashboardFilter.branches = action.payload
        ? action.payload.branches
        : null;
      state.dashboardFilter.branch_tags = action.payload
        ? action.payload.branch_tags
        : null;
    },
  },
  extraReducers: {
    [getGeneralPageDashboard.fulfilled]: (state: any, { payload }) => {
      state.loading = false;
      state.generalPageData = payload.data;
      if (payload?.error) {
        state.error = payload?.error;
      } else {
        state.error = payload?.message;
      }
    },
    [getInventoryItemsConsumtion.fulfilled]: (state: any, { payload }) => {
      state.loading = false;
      state.itemConsumtion = payload.data;
      if (payload?.error) {
        state.error = payload?.error;
      } else {
        state.error = payload?.message;
      }
    },
    [getInventoryItemsWasted.fulfilled]: (state: any, { payload }) => {
      state.loading = false;
      state.itemWasted = payload.data;
      if (payload?.error) {
        state.error = payload?.error;
      } else {
        state.error = payload?.message;
      }
    },
    [getBranchesPageData.fulfilled]: (state: any, { payload }) => {
      state.loading = false;
      state.branchesPageData = payload.data;
      if (payload?.error) {
        state.error = payload?.error;
      } else {
        state.error = payload?.message;
      }
    },
    [getBranchesPageData.rejected]: (state: any, { payload }) => {
      state.loading = true;
      state.branchesPageData = [];
    },
    [getInventoryPageData.fulfilled]: (state: any, { payload }) => {
      state.loading = false;
      state.inventoryPageData = payload.data;
      if (payload?.error) {
        state.error = payload?.error;
      } else {
        state.error = payload?.message;
      }
    },
    [getInventoryPageData.rejected]: (state: any, { payload }) => {
      state.loading = true;
      state.inventoryPageData = [];
    },
  },
});

export const { setProgressLoading, setIsDataFiltered, setDashboardFilterObj } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
